import { buildCalendlyUrl } from './attribution.js';

export const CALENDLY_URL = 'https://calendly.com/eric-accounteditor/account-editor-demo-call';
const CALENDLY_JS = 'https://assets.calendly.com/assets/external/widget.js';
const CALENDLY_CSS = 'https://assets.calendly.com/assets/external/widget.css';

export function ensureCalendly() {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (window.Calendly) return Promise.resolve(window.Calendly);
  if (window.__calendlyPromise) return window.__calendlyPromise;
  if (!document.querySelector('link[data-calendly]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CALENDLY_CSS;
    link.setAttribute('data-calendly', '1');
    document.head.appendChild(link);
  }
  window.__calendlyPromise = new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = CALENDLY_JS;
    s.async = true;
    s.onload = () => resolve(window.Calendly || null);
    s.onerror = () => resolve(null);
    document.head.appendChild(s);
  });
  return window.__calendlyPromise;
}

// Every "Book a demo" CTA links straight to the Calendly scheduler in a new tab.
// utm_content = "<page-slug>::<entryPoint>" so a booking names the page and the
// button it came from, the same convention buildCtaUrl uses for App Store links.
export function demoLinkProps(entryPoint) {
  return {
    href: buildCalendlyUrl(CALENDLY_URL, { entryPoint }),
    target: '_blank',
    rel: 'noopener',
  };
}
